module.exports = __webpack_public_path__ + "static/media/docNavLogo.b00ac10a.svg";